import ApiService from '@services/api.service'
import { store } from '@state/store'

const SystemTestService = {
  async setSystemOnTest(testDurationHours) {
    let response = await ApiService.post(
      `/systems/site/${store.state.site.siteNumber}/teststatus`,
      {
        testDurationHours: testDurationHours,
      }
    ).catch((err) => {
      throw err
    })

    store.updateSystemTest(response.data, store.state.timeZoneInfo)
  },

  async extendSystemTest(testDurationHours) {
    let response = await ApiService.post(
      `/systems/site/${store.state.site.siteNumber}/ExtendSiteTest`,
      {
        testDurationHours: testDurationHours,
      }
    ).catch((err) => {
      throw err
    })

    store.updateSystemTest(response.data, store.state.timeZoneInfo)
  },

  async prepareSiteForTwoWayTest() {
    await ApiService.post(
      `/Site/${store.state.site.siteNumber}/TwoWayTest`
    ).catch((err) => {
      throw err
    })
  },
}

export default SystemTestService
